<template>
  <main class="form-signin">
    <b-modal hide-footer v-model="rgpd_modal" size="lg" title="Règlement général sur la protection des données (RGPD)">
      <p>Les données communiquées servent à traiter les dosssiers relatifs au domaine public. Seules les responsables du
        traitement et le service instructeur sont habilités à accéder aux données communiquées. La durée de conservation
        des données est fixée à 3 ans maximum. La base juridique de traitement de données personnelles est votre
        consentement ou notre intérêt légitime en tant que communauté de communes MACS. Conformément à loi européenne
        RGPD, vous disposez d’un droit d’accès, portabilité, rectification à vos données personnelles ainsi que du droit
        d’opposition, d’effacement et de limitation au traitement de vos données personnelles pour motifs légitimes.
        Vous pouvez exercer vos droits à l’adresse dpd@cc-macs.org. En l’absence de réponse de la part de MACS sous
        30 jours, vous êtes en droit d’introduire une réclamation à l’autorité de contrôle (La CNIL).</p>
    </b-modal>
    <div class="card" id="login">
      <div class="card-body">
        <form>
          <div>
            <img style="margin-left: 80px" src="../img/MACS-Logo.png" class="logo-macs-gdpr"
              aria-placeholder="macs_gdpr" />
          </div>
          <div style="margin-top: 100px">
            <h2 class="h3 mb-3 fw-normal text-center">Inscription</h2>

            <p class="p-signup">
              Créer votre compte et rejoignez la plateforme MACS GDPR
            </p>
          </div>
          <div class="form-group">
            <label class="label-signup">Adresse email</label>
            <ValidationProvider mode="lazy" v-slot="{ errors }" rules="required|email" name="email">
              <input type="email" class="form-control form-control-lg" placeholder="Email address"
                v-model="myUserSelected.email" />
              <div class="error">{{ errors[0] }}</div>
            </ValidationProvider>
          </div>

          <div class="form-group">
            <label class="label-signup">Mot de passe</label>

            <div class="input-group">
              <span class="input-group-addon">
                <font-awesome-icon @click="showHidePass()" :icon="iconEye" class="pointeur"></font-awesome-icon>
              </span>
              <b-form-input style="height: 50px !important" v-on:keyup.enter="doLogin" :type="typePassword"
                v-model="myUserSelected.password" placeholder="Mot de passe"></b-form-input>
            </div>
          </div>
          <div class="form-group">
            <label class="label-signup">Confirmer le mot de passe</label>

            <div class="input-group">
              <span class="input-group-addon">
                <font-awesome-icon @click="showHidePass()" :icon="iconEye" class="pointeur"></font-awesome-icon>
              </span>
              <b-form-input style="height: 50px !important" v-on:keyup.enter="doLogin"
                v-model="myUserSelected.password_confirm" :type="typePassword"
                placeholder="Confirmer le mot de passe"></b-form-input>
            </div>

            <p v-if="showmsgPasswordError" style="color: red; text-align: center">
              {{ msgPasswordError }}
            </p>
          </div>

          <div class="form-group">
            <p style="text-align: center;"><a class="text-primary" href="#" @click="showModalRGPD()">
                Règlement général sur la protection des données</a></p>
          </div>

          <div class="input-group">
            <div class="row btn-register">
              <b-button type="button" block variant="warning" @click="Validate()">
                Valider
              </b-button>
              <b-button type="button" block variant="secondary" @click="BackToHome()">
                Retour
              </b-button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </main>
</template>

<script>
  import Vue from "vue";
  import Vuex from "vuex";

  export default {
    name: "Register",
    data() {
      return {
        rgpd_modal: false,
        showmsgPasswordError: false,
        msgPasswordError: "Veuillez saisir le même mot de passe",
        typePassword: "password",
        iconEye: "eye"
      };
    },
    async mounted() {
      await this.initUser();
    },
    computed: {
      myUserSelected: {
        get() {
          return this.userSelected;
        },
        set(value) {
          this.setUser(value);
        },
      },
      ...Vuex.mapGetters("User", ["userSelected"]),
    },
    methods: {
      showHidePass: function () {
        this.typePassword = this.typePassword == "password" ? "text" : "password";
        this.iconEye = this.iconEye == "eye" ? "eye-slash" : "eye";
      },
      BackToHome() {
        this.$router.push("/Login");
      },
      showModalRGPD() {
        this.rgpd_modal = true;
      },
      Validate() {

        if (this.myUserSelected.password != this.myUserSelected.password_confirm) {
          this.showmsgPasswordError = true;
        } else {
          this.showmsgPasswordError = false;
        }

        if (this.myUserSelected.password == this.myUserSelected.password_confirm) {
          this.myUserSelected.firstName = "";
          this.myUserSelected.lastName = "";
          this.myUserSelected.phone = "";
          this.addUser(this.myUserSelected);
        }
      },
      ...Vuex.mapActions("User", ["addUser", "initUser"]),
    },
  };
</script>


<style lang="css">
  body {
    display: flex;
    padding-top: 60px;
    padding-bottom: 60px;
    align-items: center;
    background-color: #f6f6f6;
  }

  .form-signin {
    width: 100%;
    max-width: 450px;
    margin: auto;
  }

  .label-signup {
    font-weight: 600;
  }

  .p-signup {
    text-align: center;
  }
</style>